import {
  TAKING_CAR_PURCHASE_SAVE_BEGIN,
  TAKING_CAR_PURCHASE_SAVE_SUCCESS,
  TAKING_CAR_PURCHASE_SAVE_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'
const TAKING_CAR_SELL_MODULE = 'TakingCarSell'

export function reducer(state, action) {
  switch (action.type) {
    case TAKING_CAR_PURCHASE_SAVE_BEGIN:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          savePending: true,
          saveSuccess: null,
          saveError: null
        }
      }
    case TAKING_CAR_PURCHASE_SAVE_SUCCESS:
    const possibleActionsArray = BFFAgent.Stock.TakingCarManagement.mapPossibleActionToOptions(action.data.possible_action)
    const isSale = action.data.new_state?.module === TAKING_CAR_SELL_MODULE
    const takingCarManagement ={
      ...state.takingCarManagement,
      savePending: false,
      saveError: null,
      saveSuccess: true,
    }
    if (isSale) {
      takingCarManagement.saleStateUpdate = action.data
      takingCarManagement.sellPossibleActions = possibleActionsArray
      if (!takingCarManagement.saveSuccessBuy){
        takingCarManagement.saveSuccessBuy = {}
      }
      takingCarManagement.saveSuccessBuy.taking_car_sell = null
    } else {
      takingCarManagement.buyStateUpdate = action.data
      takingCarManagement.buyPossibleActions = possibleActionsArray
    }

    return {
      ...state,
      takingCarManagement
    }
    case TAKING_CAR_PURCHASE_SAVE_FAILURE:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          savePending: false,
          saveSuccess: false,
          saveError: action.data
        }
      }
    default:
      return state
  }
}
